import { render } from "./EventSubText.vue?vue&type=template&id=3976b022"
import script from "./EventSubText.vue?vue&type=script&lang=js"
export * from "./EventSubText.vue?vue&type=script&lang=js"
script.render = render

export default script